export const AUTH_USER = "AUTH_USER";
export const SET_REDIRECT_URI = "SET_REDIRECT_URI";
export const AUTH_MERCHANT = "AUTH_MERCHANT";
export const MERCHANT_LOGOUT = "MERCHANT_LOGOUT";
export const SET_CART = "SET_CART";
export const SET_CHECKOUT = "SET_CHECKOUT";
export const SET_SHOPS = "SET_SHOPS";
export const SET_SHOPS_CHANGE = "SET_SHOPS_CHANGE";
export const HOME_LOAD_CHANGE = "HOME_LOAD_CHANGE";
export const USER_LOGOUT = "USER_LOGOUT";
export const SET_MERCHANT = "SET_MERCHANT";
export const SET_VIEWED_SHOP = "SET_VIEWED_SHOP";
export const SET_ADMIN_HOME = "SET_ADMIN_HOME";
